import { useMutation, useQueryClient } from "@tanstack/react-query";

import { usersQueryKey } from "@/hooks/queries/useGetUsers";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UpdateInternalUserRequest, User } from "@/types";

export function useUpdateSetUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      updateInternalUserRequest,
    }: {
      id: number;
      updateInternalUserRequest: UpdateInternalUserRequest;
    }) => {
      const path = `/users/${id.toString()}`;
      const res = await guacHttpClient.patch<
        User,
        HttpResponse<User>,
        UpdateInternalUserRequest
      >(path, updateInternalUserRequest);
      return res.data;
    },
    onSuccess: (updatedUser) => {
      queryClient.setQueryData(usersQueryKey(), (cachedData?: User[]) => {
        if (!cachedData) return cachedData;
        return cachedData.map((user) =>
          user.id === updatedUser.id ? updatedUser : user,
        );
      });
      queryClient.setQueryData(["users", updatedUser.id], updatedUser);
    },
  });
}
